import { cx } from '@orn/shared-web/utils/cx';

import { formatSubscriptionStatus, isEntitledStatus } from './accountsView';

import type { SubscriptionStatus } from '../../__generated__/globalTypes';

interface ISubscriptionBadgeProps {
  status: SubscriptionStatus | null;
}

/**
 * A subscription status, colored by whether it still entitles the household.
 * Null — a household that never subscribed — and `CANCELED` render differently
 * on purpose: `CANCELED` is the answer to "why can they not see this", and
 * collapsing the two would hide it.
 */
const SubscriptionBadge = ({ status }: ISubscriptionBadgeProps) => {
  if (status === null) {
    return (
      <span
        className="text-fg-quaternary whitespace-nowrap text-[10px] uppercase tracking-wide"
        title="This household has never had a subscription"
      >
        None
      </span>
    );
  }
  return (
    <span
      className={cx(
        'border-border-primary whitespace-nowrap rounded-sm border px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wide',
        isEntitledStatus(status) ? 'text-fg-success-primary' : 'text-fg-warning-primary'
      )}
    >
      {formatSubscriptionStatus(status)}
    </span>
  );
};

export default SubscriptionBadge;
